export const RIGHT_LEFT_PADDING = 0;
export const GAP = 10;
export const MOSAIC_CARD_MIN_WIDTH = 200;
export const MOSAIC_CARD_MAX_HEIGHT = 250;
